import settings from '../settings';

import sweetalert from 'sweetalert';
import nunjucks from 'nunjucks';
import moment from 'moment';
import Pikaday from 'pikaday';

import FacebookPostCalculator from '../model/facebook-post-calculator';
import LinkedInPostCalculator from '../model/linkedin-post-calculator';
import TwitterPostCalculator from '../model/twitter-post-calculator';
import InstagramPostCalculator from '../model/instagram-post-calculator';

import preloadNunjucks from '../preload/nunjucks';
var nunjucksEnv = preloadNunjucks();
var currentTypedValue = "";
export default class ShareBox {
    constructor() {
        this.calculators = {};

        this.scheduled = false;

        this.postId = null;
        this.currentTypedValue = "";
        this.onCreate = false;
        this.networks = $('.page__header .user-profile')
            .data('active-networks')
            .split('|');

        for (var i = 0; i < this.networks.length; i++) {
            var network_data = this.networks[i].split(';');
            var network = network_data[0];
            var account_id = network_data[1];
            var name = network_data[2];

            if (network == 'facebook' || network == 'facebookpage') {
                this.calculators[account_id] = new FacebookPostCalculator();
            } else if (network == 'linkedin' || network == 'linkedinpage') {
                this.calculators[account_id] = new LinkedInPostCalculator();
            } else if (network == 'twitter') {
                this.calculators[account_id] = new TwitterPostCalculator();
            } else if (network == 'instagram') {
                this.calculators[account_id] = new InstagramPostCalculator();
            }
        }

        this.init();
    }

    zeroPad(number) {
        return 10 > number ? '0' + number : number;
    }

    submitShares(post_id, on_create, auto = false) {

        if ($("#share-thumbnail img").attr("src")) {
            if ($("#fileUpload").length > 0 && $("#share-image-id").length == 0) {
                let dataurl = $("#share-thumbnail img").attr("src");
                var arr = dataurl.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                let list = new DataTransfer();
                const newFile = new File([u8arr], "Cropped-instagramImage", { type: mime });
                $("#fileUpload").parent().append("<input type='hidden' id='post-image-tags' name='tags' value='instagram'><input type='hidden' id='instagram-share-crop-post-id' value='"+post_id+"'><input type='hidden' id='share-image-id' value='"+$("#selected-insta-account-id").val()+"'>");
                list.items.add(newFile);
                $("#fileUpload")[0].files = list.files;
                $('#post-image-upload-form').submit();
                return false;
            }
        }else{
            if($(".social-network--instagram").length > 0){
                if($(".social-network--instagram.is-active").length > 0){
                    let instagramAccountId = $(".social-network--instagram.is-active").attr("data-account");
                    if($(".share-box--instagram--"+instagramAccountId+" input:checked").length){
                        
                    }else{
                        let postVideoId = $(".social-network--instagram.is-active").attr("data-video_id");
                        if(postVideoId!=0){
                            
                        }else{
                            alert("Don't forget to select and crop your image before sharing to Instagram.");
                            return false;
                        }
                    }
                }
                
            }
        }

        var share_count = 0;

        $('.share-form .selected-networks').remove();
        $('.share-form .on-create').remove();
        $('.share-form').append(
            '<input type="hidden" value="' +
            on_create +
            '" name="on_create"        class="on-create" />'
        );
        $('.social-network.is-active.is-connected').each(function(index, value) {
            if ($(value).data('network') != 'email') {
                share_count++;
            }
            $('.share-form').append(
                '<input type="hidden" value="' +
                $(value).data('account') +
                '" name="network[]" class="selected-networks" />'
            );
        });

        $('.share-form').append(
            '<input type="hidden" value="' +
            (auto == true ? 1 : 0) +
            '" name="auto_schedule" />'
        );

        // Build a new request to share the post
        let url = '/posts/' + post_id + '/shares',
            response;

        response = $.ajax({
            headers: settings.api_headers,
            url: url,
            data: $('.share-form').serialize(),
            type: 'POST'
        });

        // Handle a failed return
        response.fail((jqXHR, textStatus) => {
            sweetAlert({
                title: 'Sorry!',
                text: 'There was a problem sharing your post',
                type: 'error'
            });
        });

        // Handle a successful return
        response.done((data, textStatus, jqXHR) => {
            var success_text;

            if (
                auto ||
                'Schedule shares' == $('.sa-confirm-button-container button').text()
            ) {
                success_text = 'Your shares have been scheduled!';
            } else {
                success_text = 'Your post has been shared successfully!';
            }

            $.toast({
                heading: 'Success',
                text: success_text,
                icon: 'success',
                loader: true, // Change it to false to disable loader
                loaderBg: '#9EC600' // To change the background
            });

            swal.close();

            var $share_counter_span = $(
                    '#post-' +
                    post_id +
                    ' .post__view-interactions[data-type="shares"] span'
                ),
                existingText = $share_counter_span.text();

            $share_counter_span.text(Number(existingText) + Number(share_count));
        });
    }

    change__sharing_time(ev) {
        let $me = $(ev.currentTarget),
            $parent = $me.parent(),
            strDate = $('.schedule-date-select', $parent).val(),
            intHour = Number($('.schedule-time-select--hour', $parent).val()),
            intMinute = Number($('.schedule-time-select--minute', $parent).val()),
            bIsPM = 'PM' == $('.schedule-time-select--ampm', $parent).val(),
            twentyFourHour = bIsPM ?
            intHour == 12 ?
            12 :
            12 + intHour :
            intHour == 12 ?
            0 :
            intHour,
            schedule_time =
            moment(strDate, 'ddd MMM DD YYYY').format('YYYY-MM-DD') +
            ' ' +
            this.zeroPad(twentyFourHour) +
            ':' +
            this.zeroPad(intMinute) +
            ':00',
            dateObj = moment(schedule_time).toDate();

        if (dateObj.getTime() < new Date().getTime()) {
            if (false === bIsPM) {
                // lets try changing the AM to PM and see if that sorts it!
                let new_schedule_time = moment(schedule_time)
                    .add(12, 'hour')
                    .format('YYYY-MM-DD HH:mm:ss'),
                    newDateObj = moment(new_schedule_time).toDate();

                if (newDateObj.getTime() >= new Date().getTime()) {
                    dateObj = newDateObj;
                    schedule_time = new_schedule_time;

                    let $ampm = $('.schedule-time-select--ampm', $parent);
                    $ampm.val('PM');
                }
            }
        }

        if (dateObj.getTime() < new Date().getTime()) {
            $('.share-error').removeClass('visually-hidden');
            setTimeout(() => $('.sweet-alert .confirm').prop('disabled', true), 10);
        } else {
            $('.share-error').addClass('visually-hidden');
            setTimeout(() => $('.sweet-alert .confirm').prop('disabled', false), 10);
        }

        $('.share-timestamp', $parent).val(schedule_time);
    }

    click__enable_scheduler(ev) {
        ev.preventDefault();
        $(window).scrollTop(0);
        $('#share-customiser').hide();
        $('#share-scheduler').show();
        $('.share-form .schedule-date-select').trigger('change');
        this.scheduled = true;
        $('.btn--share-submit')
            .addClass('btn--share-submit-scheduled')
            .text('Schedule shares');
        $('.btn--share-method-selector').addClass('visually-hidden');
        $('.sa-confirm-button-container button').text('Schedule shares');
    }

    change__sharing_emails(ev) {
        let $me = $(ev.currentTarget),
            $my_wrapper = $me.parents('.sweet-alert');

        this.detect_confirm_sharing($my_wrapper);
    }

    set_enable_confirm_sharing($my_wrapper, enable_confirm) {
        let $confirm = $my_wrapper.find('.confirm');
        // Show the 'confirm' button
        $confirm.prop('disabled', !enable_confirm);
        if (enable_confirm) {
            $('.share-button-controls').removeClass('visually-hidden');
        } else {
            $('.share-button-controls').addClass('visually-hidden');
        }
    }

    detect_confirm_sharing($my_wrapper) {
        let enable_confirm = true,
            $active_networks = $my_wrapper.find('.social-network.is-active');

        // what does this thing do - it's messing my stuff up
        $my_wrapper.find('.postbox__counts__count:visible').each(function(k, v) {
            enable_confirm = enable_confirm && parseInt($(v).text()) >= 0;
        });

        // Finally, check that there is at least 1 network to share to
        enable_confirm = enable_confirm && !!$active_networks.length;

        // If you've chosen Email but haven't entered anything don't enable confirm
        // so add in not email or email entered

        enable_confirm =
            enable_confirm &&
            (0 == $active_networks.parent().find('.social-network--email').length ||
                '' !== $('#share--email-addresses').val());

        this.set_enable_confirm_sharing($my_wrapper, enable_confirm);
    }

    get_date_to_next_n_minutes(numMinutes) {
        let date = new Date();
        date.setMinutes(numMinutes * Math.ceil(date.getMinutes() / numMinutes));

        if (date.getTime() < new Date().getTime()) {
            date.setMinutes(date.getMinutes() + numMinutes);
        }

        return date;
    }

    
    set_defaults() {
        let date = this.get_date_to_next_n_minutes(15),
            momDate = moment(date),
            $date = $('.share-form .schedule-date-select'),
            $hour = $('.share-form .schedule-time-select--hour'),
            $minute = $('.share-form .schedule-time-select--minute'),
            $ampm = $('.share-form .schedule-time-select--ampm');

        $date.val(momDate.format('ddd MMM DD YYYY'));
        $hour.val(momDate.format('h')); // 1-12
        $minute.val(momDate.format('mm')); // 00-59
        $ampm.val(momDate.format('A')); // AM/PN
    }

    click__share(ev) {
        ev.preventDefault();

        var $me = $(ev.currentTarget),
            $my_wrapper = $me.parents('.social-connections--sharing'),
            $networks = $my_wrapper.find('.social-network.is-active');
    }

    click__submit_share(ev) {
        ev.preventDefault();
        this.submitShares(this.postId, this.onCreate);
    }

    shareLinkedinMentions(e, lastWord, textArea){
        var previousThis = this;
        var textLength = ($(textArea).val().length > 83) ?($(textArea).val().length / 83) : $(textArea).val().length;

        var i = e.target.getBoundingClientRect(),
        a = textLength * 8,
        s = i.top;
    
        $("#linkedin-mentioned-sharing").html("");
        $.ajax({ 
            url: "/linkedin-mentioned?keyword="+lastWord.replace("@",''), 
            method: "GET",
            dataType: 'JSON',
            success: function (data) {
                var html = "<ul>";
                $.each(data, (index,val) => {
                    html+= '<li data-urn="'+val.urn+'">'+((val.logoUrl) ? '<image src="'+val.logoUrl+'"/>': "<i class='fa fa-linkedin'/>") +'<a href="javascript:;">' + val.name + '</a> </li>';
                });
                html+= "</ul>";
                $("#linkedin-mentioned-sharing").html(html);
                afterResponse(a,s, data, textArea);
            },
            error: function (data) {
                console.log("error");
                console.log(data);
            }
        });
        function afterResponse(a,s, data, textArea){
            $("#linkedin-mentioned-sharing").css("left", a);
            $("#linkedin-mentioned-sharing").css("top", s);
            if(data.length > 0){
                $("#linkedin-mentioned-sharing").show();
            }else{
                $("#linkedin-mentioned-sharing").hide();
            }
            
            $("#linkedin-mentioned-sharing").find("ul").find("li").off().on("click", function () {
                var val = $(textArea).val();
                var result = val.replace('@'+lastWord, "@["+$(this).text().trim()+"]("+$(this).attr("data-urn")+")");
                $(textArea).val(result);
                previousThis.currentTypedValue = "";
                $("#linkedin-mentioned-sharing").hide();
            }),
            $("body").on("click", function () {
                $("#linkedin-mentioned-sharing").hide();
            });
        }
    }

    checkLinkedinMentions(t){
        if($(t).attr("data-network")==="linkedin" || $(t).attr("data-network")==="linkedinpage"){
            var previousThis = this;
            var socialAccountId = $(t).attr("data-account");
            $("textarea[name='share["+socialAccountId+"]']").off().on('keyup', function(ev){ 
                if(previousThis.currentTypedValue!="" && previousThis.currentTypedValue!=undefined){
                    if(ev.originalEvent.keyCode >= 65 && ev.originalEvent.keyCode <= 90){
                        if(previousThis.currentTypedValue == "@" || previousThis.currentTypedValue == "2"){
                            previousThis.currentTypedValue = ev.originalEvent.key;
                        }else{
                            previousThis.currentTypedValue = previousThis.currentTypedValue+ev.originalEvent.key;
                        }
                    }
                    if(ev.originalEvent.keyCode == 32){
                        previousThis.currentTypedValue = previousThis.currentTypedValue+ev.originalEvent.key;
                    }
                    var checkSpecailCharacterarray = [
                        "-",
                        ".",
                        "_"
                    ];
                    if(checkSpecailCharacterarray.indexOf(ev.originalEvent.key)>-1){
                        previousThis.currentTypedValue = previousThis.currentTypedValue+ev.originalEvent.key;
                    }

                    if(ev.originalEvent.keyCode == 8){
                        previousThis.currentTypedValue = previousThis.currentTypedValue.substring(0,previousThis.currentTypedValue.length-1);
                        if(previousThis.currentTypedValue == ""){
                            previousThis.currentTypedValue = "@";
                        }
                    }   
                }
              
                if(ev.originalEvent.key == "@"){
                    previousThis.currentTypedValue = ev.originalEvent.key;
                }

                console.log("check current value code", previousThis.currentTypedValue); 

                var textAra = "textarea[name='share["+socialAccountId+"]'";
                var lastWord = previousThis.currentTypedValue;
                if(lastWord!="" && lastWord!=undefined){
                    if(lastWord.length > 3){
                        previousThis.shareLinkedinMentions(ev, lastWord, textAra);
                    }
                }
               
            });
        }
    }

    click__sharing_network(ev) {
        ev.preventDefault();

        var $me = $(ev.currentTarget).toggleClass('is-active is-connected'),
            $my_wrapper = $me.parents('.sweet-alert'),
            $active_networks = $my_wrapper.find('.social-network.is-active'),
            $confirm = $my_wrapper.find('.confirm'),
            enable_confirm = true,
            count;

        // Find the sharing text box for the network and show it
        this.postHandleCheck($me.data('network'), $me.data('account'));
        $my_wrapper
            .find('.share-box--' + $me.data('network') + '--' + $me.data('account'))
            .toggleClass('is-hidden');

        // Loop all the currently visible post counts and ensure they're 0 or over
        $my_wrapper.find('.postbox__counts__count:visible').each(function(k, v) {
            if (!(parseInt($(v).text()) >= 0)) {
                $(v)
                    .parent()
                    .parent()
                    .addClass('has-error');
            }
        });

        this.detect_confirm_sharing($my_wrapper);
        this.checkLinkedinMentions($me);
    }

    create(post, post_id, on_create, images, postTextArray = [],postGeoLocations=[],video_id="", linkedinpost="") {
        this.postId = post_id;
        this.onCreate = on_create;

        on_create = typeof on_create !== 'undefined' ? on_create : false;
        on_create = on_create === true ? 1 : 0; // force int

        post = post.trim();

        // Get number of unaltered shares for this post
        var request = $.ajax({
            dataType: 'json',
            headers: {
                Accept: 'application/json'
            },
            method: 'GET',
            url: '/posts/' + post_id + '/shares/unaltered/'
        });

        request.done(function(response) {
            if (response.count >= response.threshold && response.threshold > 0) {
                if (response.count == 1) {
                    $('#unaltered_share_count').text('once');
                } else {
                    $('#unaltered_share_count').text(response.count + ' times');
                }

                $('#share-count-warning').removeClass('is-hidden');
            }
        });

        var countries=JSON.parse(localStorage.getItem("countries"));
        var postGeoLocation=[];
        if(postGeoLocations.length > 0){
            postGeoLocation=JSON.parse(postGeoLocations);
        }
        var targeted_audience=false;
        if($('.post_box_geo_targeted_audience').length>0){
            targeted_audience=($('.post_box_geo_targeted_audience').attr("data-targeted_audience")==1)?true:false;
        }

        var targetaudienceslists=JSON.parse(localStorage.getItem("targetaudienceslists"));
        var checkTargetAudience = 0;
        if(targetaudienceslists){
            checkTargetAudience=Object.keys(targetaudienceslists).length;
        }
        
        var targetAudiences={};
        if(checkTargetAudience > 0){
            targetAudiences=targetaudienceslists;
        }
        // Build the sharing form
        var htmlString = nunjucksEnv.render('html/posts/sharing.html', {
            post: post,
            linkedinpost: linkedinpost,
            postTextArray: postTextArray,
            networks: this.networks,
            countries: countries,
            postGeoLocations: postGeoLocation,
            targeted_audience:targeted_audience,
            images: images,
            has_schedule: $('.user-profile').data('has-automated-schedule'),
            restrict_customisations: $('.user-profile').data(
                'restrict-customisations'
            ),
            video_id:video_id,
            targetaudienceslists:targetAudiences
        });

        let _self = this;

        // Set the form title
        let title = '';

        // Grab a local copy of this object's calculators
        let calculators = this.calculators;

        // Build the Sweet Alert params
        let params = {
            customClass: 'sweet-alert--top sweet-alert--social',
            html: true,
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: true,
            text: htmlString,
            title: null
        };

        params.title = title;

        sweetAlert(params);

        $('.share-now').on('click', function() {
            if($(this).attr("data-share-now")=="true"){
                _self.submitShares(post_id, on_create);
            }
        });

        $('.btn--share-auto-schedule').on('click', function() {
            _self.submitShares(post_id, on_create, true);
        });

        $('.btn--share-cancel').on('click', function() {
            sweetAlert.close();

            return false;
        });

        $('.tooltip').tooltipsy({ offset: [0, -10] });

        $('.sweet-alert--top .postbox__counts__count').each(function(k, v) {
            var $count = $(v),
                calculator = $count.data('calculator'),
                $parent = $count.parents('.textarea-wrapper'),
                enable = true,
                calc,
                $share_box = $count.closest('.share-box'),
                $images = $share_box.find('.share-images-action'),
                images_selected = $share_box.find('.share-images-list').find('.active')
                .length;

            if (!!calculators[calculator]) {
                calc = calculators[calculator];

                calc.$counter = $count;
                calc.$target = $parent.find('textarea');
                calc.calculate(true);

                $parent.on('keyup', 'textarea', function(ev) {
                    calc.calculate(true);
                    if (calc.isWithinLimit()) {
                        $parent.removeClass('has-error');
                    } else {
                        $parent.addClass('has-error');
                    }

                    // If there are now no errors on textareas
                    if ($('.textarea-wrapper.has-error').length == 0) {
                        $('.sweet-alert .confirm').prop('disabled', false);
                        $('.share-button-controls').removeClass('visually-hidden');
                    } else {
                        $('.sweet-alert .confirm').prop('disabled', true);
                        $('.share-button-controls').addClass('visually-hidden');
                    }

                    // If post text has been updated, hide alert
                    var cleaned_post = post.replace(/(\r\n|\n|\r)/gm, '');
                    if (
                        cleaned_post ==
                        $parent
                        .find('textarea')
                        .val()
                        .replace(/(\r\n|\n|\r)/gm, '')
                    ) {
                        $('#share-count-warning').removeClass('is-hidden');
                    } else {
                        $('#share-count-warning').addClass('is-hidden');
                    }
                });
            }
        });

        this.setupSchedules();

        this.set_defaults();

        $('.sweet-alert .confirm').prop('disabled', true);
        $('#enable-scheduler').hide();
        $('body').removeClass('stop-scrolling');
    }

    toggle__image(ev) {
        ev.preventDefault();

        const $label = $(ev.currentTarget),
            $input = $label.find('input'),
            $share_box = $label.closest('.share-box'),
            $images_list = $share_box.find('.share-images-list'),
            $postbox_count = $share_box.find('.postbox__counts__count'),
            calculator = $postbox_count.data('calculator'),
            image_limit = $images_list.data('image-limit'),
            images_selected = $images_list.find('.active').length;

        const $img = $label.find('img');
        const imageMeetsSizeRestrictions = $img.data(
            'image-meets-size-restrictions'
        );
        const imageHeight = $img.data('image-height');
        const imageWidth = $img.data('image-width');

        if (imageMeetsSizeRestrictions !== true) {
            $input.prop('checked', false);

            return alert(
                `The resolution of this image is too large (${imageHeight}x${imageWidth}) to be shared. Please use an image that is smaller than 4096x4096 pixels.`
            );
        }



        // Check if limit has been reached and user is trying to select another
        // if (images_selected >= image_limit) {
        //     if (!$label.hasClass('active')) {
        //         let text = 'You can only select a maximum of ';
        //         if (image_limit == 1) {
        //             text += '1 image';
        //         } else {
        //             text += image_limit + ' images';
        //         }

        //         return alert(text);
        //     }
        // }

        if($label.data("network-type")=="instagram"){
            $("#selected-insta-account-id").val($label.data("network-id"));

            var shareImageCrop = function(imageTarget, requiredWidth, requiredHeight) {
                // Variables
                var $doc = $(document),
                    $cropMarker,
                    $originalImage,
                    origSrc = new Image(),
                    imageTarget = $(imageTarget).get(0),
                    imageScale,
                    imageRatio,
                    cropRatio,
                    adjustedRequiredWidth,
                    adjustedRequiredHeight,
                    eventState = {},
                    allowResize = true,
                    keyboardMove = false,
                    imageLoaded = new $.Deferred();
            
                origSrc.crossOrigin = "Anonymous";
            
                function init() {
                    origSrc.onload = function() {
                        // Check to make sure the target image is large enough
                        if (origSrc.width < requiredWidth || origSrc.height < requiredHeight) {
                            console.log('Image Crop error: The required dimensions are larger than the target image.');
                            return false;
                        }
            
                        // And neccessary html
                        $(imageTarget).wrap('<div class="ic-container"></div>').before('\
                        <div class="ic-overlay-n" id="icOverlayN"></div>\
                        <div class="ic-overlay-e" id="icOverlayE"></div>\
                        <div class="ic-overlay-s" id="icOverlayS"></div>\
                        <div class="ic-overlay-w" id="icOverlayW"></div>\
                        <div class="ic-crop-marker" id="icCropMarker">\
                            <div class="ic-resize-handle-nw" id="icResizeHandleNW"></div>\
                            <div class="ic-resize-handle-ne" id="icResizeHandleNE"></div>\
                            <div class="ic-resize-handle-sw" id="icResizeHandleSW"></div>\
                            <div class="ic-resize-handle-se" id="icResizeHandleSE"></div>\
                            <div class="ic-move-handle" id="icMoveHandle"></div>\
                        </div>\
                    ');
                        $cropMarker = $('#icCropMarker');
                        $originalImage = $(imageTarget);
                        imageScale = (origSrc.width / $originalImage.width()) * 1;
                        imageRatio = origSrc.width / origSrc.height;
                        cropRatio = requiredWidth / requiredHeight;
                        adjustedRequiredWidth = requiredWidth / (imageScale / 0.99);
                        adjustedRequiredHeight = requiredHeight / (imageScale / 0.99);
            
                        centerCropMarker();
                        repositionOverlay();
            
                        $cropMarker.on('mousedown touchstart', startResize);
                        $cropMarker.on('mousedown touchstart', '#icMoveHandle', startMoving);
                        imageLoaded.resolve();
                    };
                    if(typeof imageTarget !== "undefined"){
                        origSrc.src = imageTarget.src;
                    }
                };
            
                function startResize(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    saveEventState(e);
                    $doc.on('mousemove touchmove', resizing);
                    $doc.on('mouseup touchend', endResize);
                };
            
                function endResize(e) {
                    e.preventDefault();
                    $doc.off('mouseup touchend', endResize);
                    $doc.off('mousemove touchmove', resizing);
                };
            
                function resizing(e) {
                    var mouse = {},
                        width,
                        height,
                        left,
                        top,
                        originalWidth = $cropMarker.outerWidth(),
                        originalHeight = $cropMarker.outerHeight(),
                        originalOffset = $cropMarker.position();
                    mouse.x = (e.clientX || e.pageX || e.originalEvent.touches[0].clientX) + $(window).scrollLeft();
                    mouse.y = (e.clientY || e.pageY || e.originalEvent.touches[0].clientY) + $(window).scrollTop();
            
                    var SE = false,
                        SW = false,
                        NW = false,
                        NE = false;
            
                    if ($(eventState.evnt.target).is('#icResizeHandleSE')) {
                        SE = true;
                    } else if ($(eventState.evnt.target).is('#icResizeHandleSW')) {
                        SW = true;
                    } else if ($(eventState.evnt.target).is('#icResizeHandleNW')) {
                        NW = true;
                    } else if ($(eventState.evnt.target).is('#icResizeHandleNE')) {
                        NE = true;
                    }
            
                    if (SE) {
                        width = mouse.x - eventState.containerLeft - $originalImage.offset().left;
                        height = width / requiredWidth * requiredHeight;
                        left = eventState.containerLeft;
                        top = eventState.containerTop;
                    } else if (SW) {
                        width = eventState.containerWidth - (mouse.x - eventState.containerLeft - $originalImage.offset().left);
                        height = width / requiredWidth * requiredHeight;
                        left = mouse.x - $originalImage.offset().left;
                        top = eventState.containerTop;
                    } else if (NW) {
                        width = eventState.containerWidth - (mouse.x - eventState.containerLeft - $originalImage.offset().left);
                        height = width / requiredWidth * requiredHeight;
                        left = mouse.x - $originalImage.offset().left;
                        top = originalOffset.top + originalHeight - height;
                    } else if (NE) {
                        width = mouse.x - eventState.containerLeft - $originalImage.offset().left;
                        height = width / requiredWidth * requiredHeight;
                        left = eventState.containerLeft;
                        top = originalOffset.top + originalHeight - height;
                    }
            
                    if (
                        top >= 0 &&
                        left >= 0 &&
                        Math.round(top + height) <= Math.round($originalImage.height()) &&
                        Math.round(left + width) <= Math.round($originalImage.width())
                    ) {
                        allowResize = true;
                    }
            
                    if (allowResize) {
                        // Over top boundary
                        if (top < 0) {
                            height = originalHeight + originalOffset.top;
                            width = height / requiredHeight * requiredWidth;
                            top = 0;
                            if (NW) {
                                left = originalOffset.left - (width - originalWidth);
                            }
                            allowResize = false;
                        }
                        // Over left boundary
                        else if (left < 0) {
                            width = originalWidth + originalOffset.left;
                            height = width / requiredWidth * requiredHeight;
                            left = 0;
                            if (SE) {
                                top = originalOffset.top - (height - originalHeight);
                            }
                            allowResize = false;
                        }
                        // Over bottom boundary
                        else if (Math.round(top + height) > Math.round($originalImage.height())) {
                            height = $originalImage.height() - top;
                            width = height / requiredHeight * requiredWidth;
                            if (SW) {
                                left = originalOffset.left - (width - originalWidth);
                            }
                            allowResize = false;
                        }
                        // Over right boundary
                        else if (Math.round(left + width) > Math.round($originalImage.width())) {
                            width = $originalImage.width() - left;
                            height = width / requiredWidth * requiredHeight;
                            if (NE) {
                                top = originalOffset.top - (height - originalHeight);
                            }
                            allowResize = false;
                        }
            
                        // Check for min width / height
                        if (width > adjustedRequiredWidth && height > adjustedRequiredHeight) {
                            $cropMarker.outerWidth(width).outerHeight(height);
                            $cropMarker.css({
                                'left': left,
                                'top': top
                            });
                        } else {
                            if (SW || NW) {
                                left = left - (adjustedRequiredWidth - width);
                            }
                            if (NW || NE) {
                                top = top - (adjustedRequiredHeight - height);
                            }
                            $cropMarker.outerWidth(adjustedRequiredWidth).outerHeight(adjustedRequiredHeight);
                            $cropMarker.css({
                                'left': left,
                                'top': top
                            });
                        }
                    }
                    repositionOverlay();
                }
            
                function startMoving(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    saveEventState(e);
                    $doc.on('mousemove touchmove', moving);
                    $doc.on('mouseup touchend', endMoving);
                };
            
                function endMoving(e) {
                    e.preventDefault();
                    $doc.off('mouseup touchend', endMoving);
                    $doc.off('mousemove touchmove', moving);
                };
            
                function moving(e) {
                    var top,
                        left,
                        mouse = {},
                        touches;
                    e.preventDefault();
                    e.stopPropagation();
            
                    touches = e.originalEvent.touches;
            
                    mouse.x = (e.clientX || e.pageX || touches[0].clientX) + $(window).scrollLeft();
                    mouse.y = (e.clientY || e.pageY || touches[0].clientY) + $(window).scrollTop();
            
                    top = mouse.y - (eventState.mouseY - eventState.containerTop);
                    left = mouse.x - (eventState.mouseX - eventState.containerLeft);
                    if (top < 0) {
                        top = 0;
                    }
                    if (top + $cropMarker.outerHeight() > $originalImage.height()) {
                        top = $originalImage.height() - $cropMarker[0].getBoundingClientRect().height;
                    }
                    if (left < 0) {
                        left = 0;
                    }
                    if (left + $cropMarker.outerWidth() > $originalImage.width()) {
                        left = $originalImage.width() - $cropMarker[0].getBoundingClientRect().width;
                    }
                    $cropMarker.css({
                        'top': top,
                        'left': left
                    });
                    repositionOverlay();
                };
            
                document.addEventListener('keydown', function(e) {
                    if(typeof $cropMarker !== "undefined"){
                        var top,
                            left,
                            shiftAmount,
                            top = $cropMarker.position().top,
                            left = $cropMarker.position().left;
                        if (e.shiftKey) {
                            shiftAmount = 10;
                        } else {
                            shiftAmount = 1;
                        }
            
                        if (e.keyCode === 37) {
                            left = left - shiftAmount;
                        } else if (e.keyCode === 38) {
                            top = top - shiftAmount;
                        } else if (e.keyCode === 39) {
                            left = left + shiftAmount;
                        } else if (e.keyCode === 40) {
                            top = top + shiftAmount;
                        }
            
                        if (top < 0) {
                            top = 0;
                        }
                        if (top + $cropMarker.outerHeight() > $originalImage.height()) {
                            top = $originalImage.height() - $cropMarker[0].getBoundingClientRect().width;
                        }
                        if (left < 0) {
                            left = 0;
                        }
                        if (left + $cropMarker.outerWidth() > $originalImage.width()) {
                            left = $originalImage.width() - $cropMarker[0].getBoundingClientRect().width;
                        }
            
                        if (keyboardMove) {
                            $cropMarker.css({
                                'top': top,
                                'left': left
                            });
                            repositionOverlay();
                        }
                    }
                });
            
                $doc.click(function(e) {
                    if ($(e.target).closest('.ic-container').length) {
                        keyboardMove = true;
                    } else {
                        keyboardMove = false;
                    }
                })
            
                var saveEventState = function(e) {
                    eventState.containerWidth = $cropMarker.outerWidth();
                    eventState.containerHeight = $cropMarker.outerHeight();
                    eventState.containerLeft = $cropMarker.position().left;
                    eventState.containerTop = $cropMarker.position().top;
                    eventState.mouseX = (e.clientX || e.pageX || e.originalEvent.touches[0].clientX) + $(window).scrollLeft();
                    eventState.mouseY = (e.clientY || e.pageY || e.originalEvent.touches[0].clientY) + $(window).scrollTop();
                    eventState.evnt = e;
                };
            
                var centerCropMarker = function() {
                    if (cropRatio > imageRatio) {
                        $cropMarker.outerWidth($originalImage.width());
                        $cropMarker.outerHeight($cropMarker.outerWidth() / requiredWidth * requiredHeight);
                        $cropMarker.css({
                            top: ($originalImage.height() - $cropMarker.height()) / 2 + 'px',
                            left: 0
                        });
                    } else {
                        $cropMarker.outerHeight($originalImage.height());
                        $cropMarker.outerWidth($cropMarker.outerHeight() / requiredHeight * requiredWidth);
                        $cropMarker.css({
                            left: ($originalImage.width() - $cropMarker.width()) / 2 + 'px',
                            top: 0
                        });
                    }
                }
            
                function repositionOverlay() {
                    var imgWidth = $originalImage[0].getBoundingClientRect().width,
                        imgHeight = $originalImage[0].getBoundingClientRect().height,
                        cropTop = $cropMarker.position().top,
                        cropLeft = $cropMarker.position().left,
                        cropWidth = $cropMarker[0].getBoundingClientRect().width,
                        cropHeight = $cropMarker[0].getBoundingClientRect().height,
                        cropBorder = parseFloat($cropMarker.css('border-top-width'));
                    $('#icOverlayN').css({
                        right: imgWidth - cropLeft - cropWidth,
                        height: cropTop,
                        left: cropLeft
                    });
                    $('#icOverlayE').css({
                        left: cropLeft + cropWidth
                    });
                    $('#icOverlayS').css({
                        right: imgWidth - cropLeft - cropWidth,
                        top: cropTop + cropHeight,
                        left: cropLeft
                    });
                    $('#icOverlayW').css({
                        width: cropLeft
                    });
                };
            
                // Crop to required size
                this.crop = function() {
                    var cropCanvas,
                        img = new Image(),
                        scale = origSrc.width / $originalImage.width(),
                        left = Math.round($cropMarker.position().left * scale),
                        top = Math.round($cropMarker.position().top * scale),
                        width = Math.round($cropMarker.outerWidth() * scale),
                        height = Math.round($cropMarker.outerHeight() * scale);
                    results;
                    
                    cropCanvas = document.createElement('canvas');
                    cropCanvas.width = requiredWidth;
                    cropCanvas.height = requiredHeight;
                    cropCanvas.getContext('2d').drawImage(origSrc, left, top, width, height, 0, 0, requiredWidth, requiredHeight);
            
                    img.src = cropCanvas.toDataURL();
            
                    var results = {
                        img: img,
                        left: left,
                        top: top,
                        width: width,
                        height: height,
                        requiredWidth: requiredWidth,
                        requiredHeight: requiredHeight
                    };
                    return results;
                }
            
                this.position = function(left, top, width, height) {
                    $.when(imageLoaded).done(function() {
                        var scale = origSrc.width / $originalImage.width();
                        left = Math.round(left / scale),
                            top = Math.round(top / scale),
                            width = Math.round(width / scale),
                            height = Math.round(height / scale);
                        $cropMarker.outerWidth(width).outerHeight(height);
                        $cropMarker.css({
                            'left': left,
                            'top': top
                        });
                        repositionOverlay();
                    });
                }
            
                this.cropReset = function() {
                    centerCropMarker();
                    repositionOverlay();
                }
            
                // Viewport resize
                $(window).resize(function() {
                    imageScale = origSrc.width / $originalImage.width();
                    adjustedRequiredWidth = requiredWidth / imageScale;
                    adjustedRequiredHeight = requiredHeight / imageScale;
                    centerCropMarker();
                    repositionOverlay();
                });
            
                init();
            };
        
            function shareEnableCropping(){
                var image = $('#share-fullImage');
                var fixedheight = 400;
                var fixedWidth= 400;
                var variableWidth = 250;
                var naturalWidth = image[0].naturalWidth;
                var naturalHeight = image[0].naturalHeight;
                if(naturalHeight < fixedheight || naturalWidth < fixedWidth){
                    alert("For Instagram croping: Image size should be grater than "+fixedheight+"px * "+fixedWidth+"px.");
                    return false;
                }
                if(naturalHeight > naturalWidth){
                    var  w = (naturalWidth / 2).toFixed();
                    if(w > fixedWidth){
                        var wadd = (w /1) + variableWidth;
                        if(wadd <= naturalWidth){
                            fixedWidth = wadd;
                            fixedheight = wadd;
                        }else{
                            fixedWidth = w;
                            fixedheight = w;
                        }
                    }
                }else if(naturalHeight == naturalWidth){
                    fixedWidth = naturalWidth;
                    fixedheight = naturalHeight;
                }else{
                    var  h = (naturalHeight / 2).toFixed();
                    if(h > fixedheight){
                        var hadd = (h / 1) + variableWidth;
                        if(hadd <= naturalHeight){
                            fixedheight = hadd;
                            fixedWidth = hadd;
                        }else{
                            fixedheight = h;
                            fixedWidth = h;
                        }
                    }
                }
                
                var newImage = new shareImageCrop('#share-fullImage', fixedWidth, fixedheight);
                $("#share-crop").show();
                $("#share-cropEdit").hide();
                $('#share-crop').off().on('click', function() {
                    $("#share-cropEdit").show();
                    $("#share-saveCroppedImageSection").show();
                    var results = newImage.crop();
                    $('#share-thumbnail').html(results.img);
                    $('#share-sectionResize').addClass('hidden');
                    $('#share-sectionThumbnail').removeClass('hidden');
                });
                $('#share-cropEdit').off().on('click', function() {
                    $("#share-cropEdit").hide();
                    $("#share-saveCroppedImageSection").hide();
                    $('#share-sectionResize').removeClass('hidden');
                    $('#share-sectionThumbnail').addClass('hidden');
                });
                $("#share-saveCroppedImage").off().on("click",function(){
                    alert("save image");
                });
            }
        
            function shareCropImage(img){
                $(img).attr('id', 'share-fullImage');
                $('#share-imageResize').html(img);
                $('#share-sectionResize').removeClass('hidden');
                $('#share-sectionThumbnail').removeClass('hidden');
                shareEnableCropping();
            }
        
            $("#share-instagram-image-crop").addClass("hidden");
            $("#share-image-crop-section").removeClass("hidden");
            var xhr = new XMLHttpRequest(); 
            var targelUrl= $img[0].src;
            xhr.open("GET",targelUrl.replace('http://', 'https://'), true);   
            xhr.setRequestHeader('Access-Control-Allow-Origin', '*'); 
            xhr.setRequestHeader('Cache-Control', 'no-cache'); 
            xhr.withCredentials = false; 
            xhr.responseType = "blob";
            xhr.onload = function (e) {
                var reader = new FileReader();
                reader.onload = function(event) {
                    var img = new Image();
                    img.onload = function() {
                        shareCropImage(img);
                    }
                    img.src = event.target.result;
                }
                var file = this.response;
                reader.readAsDataURL(file)
            };
            xhr.send()
        }else{
            // Add active class to label
            $label.toggleClass('active');

            // Toggle checkbox
            $input.prop('checked', !$input.prop('checked'));
            // Re-calculate characters remaining
            // if (!!this.calculators[calculator]) {
            //     this.calculators[calculator].calculate(true);
            // }
        }
    }

    init() {
        // TODO: Move this to a __destroy-like method
        $('body')
            .off('change', '.share-form .schedule-date-select')
            .off('change', '.share-form .schedule-time-select--hour')
            .off('change', '.share-form .schedule-time-select--minute')
            .off('change', '.share-form .schedule-time-select--ampm')
            .off('click', '.share-form .btn--share-manual-schedule')
            .off('click', '.social-connections--sharing .social-network')
            .off('click', '.social-connections--sharing .confirm')
            .off('click', '.share-images-action');

        $('body')
            .on(
                'keyup',
                '#share--email-addresses',
                this.change__sharing_emails.bind(this)
            )
            .on(
                'change',
                '.share-form .schedule-date-select',
                this.change__sharing_time.bind(this)
            )
            .on(
                'change',
                '.share-form .schedule-time-select--hour',
                this.change__sharing_time.bind(this)
            )
            .on(
                'change',
                '.share-form .schedule-time-select--minute',
                this.change__sharing_time.bind(this)
            )
            .on(
                'change',
                '.share-form .schedule-time-select--ampm',
                this.change__sharing_time.bind(this)
            )
            .on(
                'click',
                '.share-form .btn--share-manual-schedule',
                this.click__enable_scheduler.bind(this)
            )
            .on(
                'click',
                '.social-connections--sharing .social-network',
                this.click__sharing_network.bind(this)
            )
            .on(
                'click',
                '.social-connections--sharing .confirm',
                this.click__share.bind(this)
            )
            .on('click', '.share-images-action', this.toggle__image.bind(this))
            .on('keyup', 'textarea', this.keyup__textarea.bind(this));
    }

    setupSchedules() {
        var picker = new Pikaday({
                field: $('#date-picker-0')[0],
                format: 'ddd MMM DD YYYY'
            }),
            _self = this;

        $('.has-repeatable').each(function(k, v) {
            var $me = $(v),
                $repeat = $me.find('.is-repeatable').first(),
                $trigger = $me.find('.repeatable__repeat'),
                $clone,
                max = $me.data('repeat-max') || false;

            $me.on('click', '.repeatable__repeat', function(ev) {
                ev.preventDefault();

                // Remove focus on the button
                $trigger.blur();

                // Only keep going if there is no maximum
                if (max === false || $me.find('.is-repeatable').length < max) {
                    // Show the button
                    $trigger.show();

                    // Make a new version of the same thing you clicked
                    $clone = $repeat.clone();

                    $clone.appendTo($me);

                    // Get the next dp
                    var $new_dp = $clone.find('.datepicker')[0];

                    // Add to the next dp
                    var picker = new Pikaday({
                        field: $new_dp,
                        format: 'ddd MMM DD YYYY'
                    });

                    let date = _self.get_date_to_next_n_minutes(15),
                        momDate = moment(date),
                        $date = $('.schedule-date-select', $clone),
                        $hour = $('.schedule-time-select--hour', $clone),
                        $minute = $('.schedule-time-select--minute', $clone),
                        $ampm = $('.schedule-time-select--ampm', $clone);

                    $date.val(momDate.format('ddd MMM DD YYYY'));
                    $hour.val(momDate.format('h')); // 1-12
                    $minute.val(momDate.format('mm')); // 00-59
                    $ampm.val(momDate.format('A')); // AM/PN
                    $hour.trigger('change');
                    // Remove the plus if there are no more
                    if (!!max && $me.find('.is-repeatable').length >= max) {
                        $trigger.hide();
                    }
                }

                // Show the minuses
                $('.repeatable__repeat_remove').removeClass('visually-hidden');
            });

            $me.on('click', '.repeatable__repeat_remove', function(ev) {
                ev.preventDefault();

                let $ct = $(ev.currentTarget),
                    $p = $ct.parent('.is-repeatable');

                $p.remove();

                // Only one left? Hide the minus
                if (1 == $me.find('.is-repeatable').length)
                    $('.repeatable__repeat_remove').addClass('visually-hidden');
            });
        });
    }

    /**
     * Bound to the keyup event of text areas.
     * @param {*} ev
     */
    keyup__textarea(ev) {
        // Work out the network and account id from the ev.target.id
        const regex = /(?:[a-z]*)--(?<network>[a-z]*)--(?<account_id>[a-z0-9]*)/;
        const matches = ev.target.id.match(regex);
        if (!matches) {
            return false;
        }

        const { network, account_id } = matches.groups;

        this.postHandleCheck(network, account_id);
    }

    /**
     * Check to see if the post contains a social media handle that doesn't make sense in the current social media network
     * Currently, we only look for Twitter handles
     * @param {string} network
     * @param {number} account_id
     */
    postHandleCheck(network, account_id) {
        // Ignore twitter networks
        if (network === 'twitter') {
            return;
        }

        const textAreaSelector = `textarea#share--${network}--${account_id}`;
        const handleWarningSelector = `div#handle-warning--${network}--${account_id}`;
        const $textArea = $(textAreaSelector);

        // If we find a Twitter handle, hide or show the warning
        if (this.containsTwitterHandle($textArea.val())) {
            $(handleWarningSelector).removeClass('is-hidden');
        } else {
            $(handleWarningSelector).addClass('is-hidden');
        }
    }

    containsTwitterHandle(text) {
        const regex = /(?:^|[^@\w])(@\w{1,15})\b/g;
        const matches = text.match(regex);

        if (!matches) {
            return false;
        }

        return true;
    }
}